import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { api } from "../utils/hostname";
import url from "../url";

export type BodyAssignCashback = {
  loyaltyRewardId: string;
};

export const request = (body: BodyAssignCashback) =>
  api(true, true).post(url.config.api.loyalty.assignCashback, body);

export const useAssignCashback = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    mutationKey: ["cashback assign"],
    mutationFn: request,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["user cashbacks"] });
    },
  });

  const navigate = useNavigate();
  const bonusPath = url.routes.profile.bonus();

  const handleAssignCashback = (body: BodyAssignCashback) => {
    mutate(body, {
      onSuccess: () => {
        navigate(bonusPath);
      },
    });
  };

  return { handleAssignCashback };
};
